import { Skeleton } from "@/components/ui/skeleton";

export const HomePageSkeleton = () => {
  return (
    <div className="h-screen bg-background flex flex-col overflow-hidden">
      {/* Header Skeleton */}
      <div className="fixed top-0 left-0 right-0 z-50 h-[60px] bg-background border-b px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-8 rounded-md" />
          <Skeleton className="h-5 w-24" />
        </div>
        <Skeleton className="h-8 w-20 rounded-full" />
      </div>

      {/* Main Content Skeleton */}
      <main className="flex-1 flex flex-col overflow-hidden pt-[60px]">
        {/* Chat Area Skeleton */}
        <div className="flex-1 bg-card flex flex-col p-4 space-y-4">
          {/* Messages skeleton */}
          <div className="flex-1 space-y-4">
            {/* Assistant message */}
            <div className="flex gap-3">
              <Skeleton className="h-8 w-8 rounded-full shrink-0" />
              <div className="space-y-2 flex-1">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            </div>
            
            {/* User message */}
            <div className="flex gap-3 justify-end">
              <div className="space-y-2 flex-1 flex flex-col items-end">
                <Skeleton className="h-4 w-1/3" />
              </div>
              <Skeleton className="h-8 w-8 rounded-full shrink-0" />
            </div>
            
            {/* Another assistant message */}
            <div className="flex gap-3">
              <Skeleton className="h-8 w-8 rounded-full shrink-0" />
              <div className="space-y-2 flex-1">
                <Skeleton className="h-4 w-2/3" />
                <Skeleton className="h-4 w-1/2" />
                <Skeleton className="h-4 w-3/5" />
              </div>
            </div>
          </div>
          
          {/* Input area skeleton */}
          <div className="border-t pt-4">
            <div className="flex gap-2">
              <Skeleton className="h-12 flex-1 rounded-xl" />
              <Skeleton className="h-12 w-12 rounded-xl" />
            </div>
          </div>
        </div>
      </main>

      {/* Footer Skeleton */}
      <div className="border-t py-2 flex justify-center">
        <Skeleton className="h-3 w-20" />
      </div>
    </div>
  );
};
